module.exports = " <div class=\"bottom-bar greentone\"> <img src=" + require("../assets/disk.gif") + " data-cmd=save v-if=\"showDisk && state.readyForSave\"> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BottomBar.vue
// module id = 173
// module chunks = 2